const RISK_RULES = [
  {
    id: "non_sempre",
    patterns: ["non lo facciamo sempre", "non sempre", "di solito"],
    response: "Non dirlo. Rispondi solo su cio che e documentato.",
  },
  {
    id: "non_scritto",
    patterns: ["non e scritto", "non l'abbiamo scritto", "non abbiamo scritto"],
    response: "Mostra la procedura, non improvvisare. Se manca, segna NON OK.",
  },
  {
    id: "memoria",
    patterns: ["lo facciamo a memoria", "a memoria"],
    response: "Mostra la procedura, non la memoria.",
  },
  {
    id: "non_so",
    patterns: ["non so", "boh", "non saprei"],
    response: "Fermati. Recupera la prova o segna NON OK e passa all'azione correttiva.",
  },
  {
    id: "documento_mancante",
    patterns: ["non abbiamo il documento", "non trovo il documento", "documento non c'e"],
    response: "Non improvvisare. Segna NON OK e registra il recupero del documento.",
  },
];

function normalize(text) {
  return String(text || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function detectRiskyPhrase(text) {
  const input = normalize(text);
  if (!input.trim()) return null;
  return RISK_RULES.find((rule) =>
    rule.patterns.some((pattern) => input.includes(normalize(pattern)))
  ) || null;
}
